import { render, staticRenderFns } from "./staff-add.vue?vue&type=template&id=81927c04&scoped=true"
import script from "./staff-add.vue?vue&type=script&lang=js"
export * from "./staff-add.vue?vue&type=script&lang=js"
import style0 from "./staff-add.vue?vue&type=style&index=0&id=81927c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81927c04",
  null
  
)

export default component.exports